import { ArticleHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { MapOfferCardDescriptionContainer } from '../../../containers/MapOfferCardDescriptionContainer';
import { IFavoriteEntity } from '../../../types/favoriteEntity';
import { Address } from '../../Address';
import { Text } from '../../Text';
import { Undergrounds } from '../../Undergrounds';

interface IInfoProps {
  offer: IFavoriteEntity;
}

export const Info: React.FC<IInfoProps> = ({ offer }) => {
  const { title, geo, bargainTerms, description, fullUrl } = offer;

  return (
    <div className={styles['info_container']}>
      <div className={styles['title']}>
        <Text color="blue" bold>
          <a href={fullUrl} className={styles['title_link']} target="_blank" rel="noreferrer">
            {title}
          </a>
        </Text>
      </div>
      {geo && (
        <div className={styles['geo_info']} data-testid="geo_info">
          <Undergrounds undergrounds={geo.undergrounds} />
          <Address address={geo.address} />
        </div>
      )}
      {bargainTerms && bargainTerms.priceText && (
        <div className={styles['price_info']} data-testid="price_info">
          <ArticleHeading2>{bargainTerms.priceText}</ArticleHeading2>
        </div>
      )}
      {description && <MapOfferCardDescriptionContainer description={description} />}
    </div>
  );
};
